import Autocomplete from "@material-ui/lab/Autocomplete";
import { AutocompleteValidator } from "utils/Validators/CommonValidator";
/* core components */
import React from "react";
//import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import TextField from "@material-ui/core/TextField";
import conf from "config/env.conf.js";
//import { UserInfoContext } from "contexts/users";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxUniversity = props => {
  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + "/ms/university",
    []
  );
  const [error, setError] = React.useState(false);
  const [helperText, setHelperText] = React.useState("");

  let content = (
    <TextField disabled label="เลือกมหาวิทยาลัย" margin="normal" fullWidth />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    data = fetchData.data.map(v => {
      return { id: v.universityId, value: v.universityName };
    });
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        disabled={props.disabled}
        id="listBoxUniversity"
        options={data}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        value={props.value}
        getOptionLabel={option => option.value}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={AutocompleteValidator(
          props.onChange,
          props.validators,
          setError,
          setHelperText
        )}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label="มหาวิทยาลัย"
              margin="normal"
              error={error}
              fullWidth
              helperText={helperText}
            />
          );
        }}
        {...props.customProps}
      />
    );
  }

  return content;
};
export default ListboxUniversity;
